import lightGallery from 'lightgallery'

class Gallery {
    constructor(){
        if(document.querySelector('#lightgallery')){
            this.lightGallery = document.querySelector('#lightgallery')
            lightGallery(this.lightGallery,{
                download: false,
                controls: true,
                counter: false,
                closable: true,
                hideScrollbar: true,
                licenseKey: '95B1CD2D-D1B04F80-88946A36-9F1072C6'
            });
        }
        if(document.querySelector('#lightgallery2')){
            this.lightGallery = document.querySelector('#lightgallery2')
            lightGallery(this.lightGallery,{
                download: false,
                controls: true,
                counter: false,
                closable: true,
                hideScrollbar: true,
                licenseKey: '95B1CD2D-D1B04F80-88946A36-9F1072C6'
            });
        }
    }
}

export default Gallery